// workbookRules.ts
export const fersNoPenaltyRules = [
  // Each entry: minService => retireAge
  // If retireAge = "MRA", then use the user’s MRA (Minimum Retirement Age).
  {
    minService: 30,
    retireAge: "MRA", // i.e. 30 yrs => MRA
  },
  {
    minService: 20,
    retireAge: 60, // 20 yrs => 60
  },
  {
    minService: 5,
    retireAge: 62, // 5 yrs => 62
  },
];

export const fersEarliestRules = [
  {
    minService: 10,
    retireAge: "MRA", // 10+ => MRA (with 5% penalty if <62)
  },
  {
    minService: 5,
    retireAge: 62, // 5+ => 62
  },
];
